/** True if `on` falls within [periodStartDate, periodEndDate] (end null = open). */
export const isActiveOn = (
  periodStartDate: string,
  periodEndDate: string | null,
  on: Date
): boolean => {
  const onStr = on.toISOString().slice(0, 10);
  return (
    periodStartDate <= onStr && (periodEndDate === null || periodEndDate >= onStr)
  );
};

/** Case-insensitive substring match across fields; empty query matches all. */
export const matchesSearch = (fields: string[], query: string): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => f.toLowerCase().includes(q));
};
